import { accessService } from '@shared/api';

import type { Account } from '../model/types';

export type GetAccountResponse = Account;

export const getAccount = () =>
  accessService.get<GetAccountResponse>('/users/me').then((response) => response.data);
